import { authFetch } from '~/services/fetch'

interface UserGroupActionsParams {
  readonly origin?: 'station' | 'userGroup' | null
  readonly user_id?: number | null
  readonly station_id?: number | null
  readonly userGroup_id?: number | null
  readonly action?: string | null
  readonly start_date: string
  readonly finish_date: string
  readonly page?: number
  readonly limit?: number
  readonly orders?: readonly { readonly field: string; readonly sort: string }[]
}

export async function getUserGroupActionsLogs(params: UserGroupActionsParams) {
  const { orders, ...otherParams } = params
  const response = await authFetch({
    url: '/logs/group-actions',
    method: 'POST',
    data: {
      ...otherParams,
      orders: orders || [{ field: 'created_at', sort: 'desc' }],
    },
  })

  return response.data
}

export const getUserGroupLogDetails = async (id: number): Promise<any> => {
  try {
    const response = await authFetch({
      url: `/logs/details/${id}`,
      method: 'GET',
    })
    if (!response.status || response.status !== 200) {
      throw new Error('Erro ao buscar detalhes do log')
    }
    return response.data
  } catch (error) {
    console.error('Erro na requisição:', error)
    throw error
  }
}
